import { ConditionValueTypes } from 'app/components/filters/types';
import { AdvancedSearchTypes } from 'app/types-shared';

export const getTextFieldConditionTypesValueData =
  (advancedField: AdvancedSearchTypes,
    conditionValueType: ConditionValueTypes,
    conditionValueSubType?: ConditionValueTypes[]
  ) => {
    const mappedConditionTypes = {
      [ConditionValueTypes.default]: {
        operator: advancedField.valueOperator,
        dbFunction: advancedField.dbFunctionValue
      },
      [ConditionValueTypes.notSpecified]: {
        operator: advancedField.valueOperator3,
        dbFunction: advancedField.dbFunctionValue3
      }
    }[conditionValueType];

    const subOptionsValue = conditionValueSubType && conditionValueSubType.length > 0 && {
      ...(conditionValueSubType.some(item => item === ConditionValueTypes.matchExact) && {
        operator: advancedField.valueOperator2,
        dbFunction: advancedField.dbFunctionValue2
      })
    };

    return subOptionsValue || mappedConditionTypes;
  };
